
import '@/assets/scss/index.scss'

import _ from 'lodash'
import * as ds from '~/scriptData/ds/dsCommon'
import Category from '~/components/ds/common/Category.vue'
// import TabCmp from '~/components/ds/common/TabCmp.vue'
import Matrial from '@/components/ds/common/Material.vue'
import { pdMixin } from '~/mixin/pd/pdMixin'
import * as category from '@/constants/category'

export default {
  name: 'BundleProductAccount',
  components: {
    Matrial,
    //   TabCmp
    Category
  },
  mixins: [pdMixin],
  layout: 'pubLayout',
  props: {
    exhData: {
      type: Object,
      default () { return {} }
    },
    cnrData: {
      type: [Array, Object],
      default () { return [] }
    },
    exhCnrId: { // 코너 ID(메인 배너 ID)
      type: String,
      default: ''
    },
    exhCmptmtId: { // 구좌 ID
      type: String,
      default: ''
    },
    lgCtgrNo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dsFnc: ds,
      cateData: [],
      currentTab: '0'
    }
  },
  computed: {
  },
  created () {
    this.fetchCategory()
  },
  methods: {
    async fetchCategory () {
      const response = await this.$AxiosBuilder
        .data({ exhCtgrNos: [category.CATEGORY_BUNDLE_HOME_ID] })
        .build()
        .post('/ds/ctgr')
      this.cateData = response.data.data
      console.log('this.cateData', this.cateData)
    },
    filterBundleProducts (categoryId) {
      this.$store.commit(
        'ds/setFiltetedBundleProducts',
        categoryId
          ? _.chain(this.cnrData)
            .map(data =>
              _(data)
                .filter(
                  data => _.size(data.bundleCategories) > 0 &&
                    _.size(
                      _.filter(
                        data.bundleCategories,
                        category => category.exhCtgrNo === categoryId
                      )
                    ) > 0
                )
                .map(category => category.bunPdNo)
                .value()
            )
            .flatten()
            .value()
          : null
      )
    },
    handleSelectedCategory (categoryId) {
      this.filterBundleProducts(categoryId)
    },
    handleTabChange (id) {
      console.log('id', id)
      this.currentTab = id
    }
  }
}
